import React, { useState, useEffect } from 'react';
import "./LoginPage.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; // ✅ 추가
import { loginUser } from "../../api/login";
import { sendPasswordResetEmail } from "../../api/publicApi";

const LoginPage = () => {
  const navigate = useNavigate(); // ✅ 라우터 이동 훅
  const [showForgotPw, setShowForgotPw] = useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isRemembered, setIsRemembered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ 로컬스토리지에 저장된 이메일 불러오기
  useEffect(() => {
    const savedUserId = localStorage.getItem("rememberedUserId");
    if (savedUserId) {
      setUserId(savedUserId);
      setIsRemembered(true);
    }
  }, []);

  // ✅ 로그인 핸들러
  const handleLogin = async (e) => {
    e.preventDefault(); // 엔터 입력 시 새로고침 방지

    if (!userId || !password) {
      Swal.fire("Error", "아이디와 비밀번호를 입력하세요.", "error");
      return;
    }

    try {
      const res = await loginUser({ userId, password });
      console.log("로그인 성공:", res);

      Swal.fire("Success", "로그인 성공!", "success");

      localStorage.setItem("accessToken", res.access_token);
      localStorage.setItem("refreshToken", res.refresh_token);

      // ✅ Remember me 기능 처리
      if (isRemembered) {
        localStorage.setItem("rememberedUserId", userId);
      } else {
        localStorage.removeItem("rememberedUserId");
      }

      // 로그인 성공 후 페이지 이동
      window.location.href = "/";
    } catch (err) {
      console.error("로그인 실패:", err);
      Swal.fire("Error", "로그인 실패. 아이디/비밀번호를 확인하세요.", "error");
    }
  };

  // ✅ 비밀번호 재설정 요청
  const handleSubmit = async () => {
    if (!email) {
      alert("이메일을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      const data = { email };
      const res = await sendPasswordResetEmail(data);
      console.log("📩 비밀번호 재설정 이메일 전송 응답:", res);
      alert("비밀번호 재설정 이메일이 발송되었습니다. 메일함을 확인해주세요.");
      setShowForgotPw(false);
    } catch (error) {
      console.error("❌ 이메일 전송 실패:", error);
      alert("비밀번호 재설정 이메일 전송 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='logincontainer'>
      <div className='background' />

      {!showForgotPw ? (
        <form className='logincomponent' onSubmit={handleLogin}>
          <div className='Login_TitleContainer'>Log in</div>

          <input
            type="email"
            className="Login_NameTextFelid"
            required
            placeholder="E-mail address"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />

          <input
            type="password"
            className="Login_NameTextFelid"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className='custom-checkbox-wrapper'>
            <label className='custom-checkbox'>
              <input
                type='checkbox'
                checked={isRemembered}
                onChange={(e) => setIsRemembered(e.target.checked)}
                style={{ opacity: "0", width: "0.1px" }}
              />
              <span className='checkmark' />
            </label>
            Remember me
          </div>

          <button type="submit" className='loginbtn'>
            <h3>Log in</h3>
          </button>

          <div className='signuplinkContainer'>
            <div>Don't have an account?</div>
            <div
              className='signuplink'
              onClick={() => navigate("/signup")} // ✅ 클릭 시 이동
            >Sign up</div>
          </div>

          <div className='ForgotlinkContainer'>
            <div>Forgot password?</div>
            <div className='Forgotlink' onClick={() => setShowForgotPw(true)}>
              Click here
            </div>
          </div>
        </form>
      ) : (
        <div className='ForgotPasswordcomponent'>
          <div className='Login_TitleContainer'>Forgot your Password?</div>

          <div className='ForgotDescription'>
            <div>Enter your user ID or email you registered with.</div>
            <div>We'll send you a link to reset your password.</div>
          </div>

          <input
            type='email'
            className='Login_NameTextFelid'
            placeholder='E-mail address'
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button
            className='forgotbtn'
            onClick={handleSubmit}
            disabled={isLoading}
            style={{
              opacity: isLoading ? 0.6 : 1,
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
          >
            {isLoading ? "Sending..." : "Submit"}
          </button>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
